export default "__VITE_ASSET__BIMyZKUj__"